import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login" }

import { onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { notification } from 'ant-design-vue'
import { authStore } from '@/stores/auth'
import { ls } from '@/ls'


export default /*#__PURE__*/_defineComponent({
  __name: 'O365LoginSucceeded',
  setup(__props) {

const O365_REDIRECT_STORAGE_KEY = 'constructionO365LoginRedirect'
const route = useRoute()
const router = useRouter()

onMounted(() => {
  const token = route.query.token as string

  authStore().getDetailsForO365User(token).then(() => {
    redirectAfterLogin()
  }).catch(() => {
    notification.error({ message: 'Fout tijdens inloggen!', description: 'Er is iets mis gegaan. Probeer het later nog een keer.' })
    router.push({ name: 'Login' })
  })
})

function redirectAfterLogin () : void {
  const redirectPath = getSafeRedirectPath()
  ls.remove(O365_REDIRECT_STORAGE_KEY)

  if (redirectPath) {
    router.push(redirectPath)
    return
  }

  router.push({ name: 'Dashboard' })
}

function getSafeRedirectPath () : string | null {
  const redirect = ls.get(O365_REDIRECT_STORAGE_KEY)
  if (typeof redirect !== 'string') {
    return null
  }

  if (!redirect.startsWith('/') || redirect.startsWith('//') || redirect.includes('://')) {
    return null
  }

  return redirect
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})